import { FC, lazy } from 'react';
import { Route, Switch } from 'react-router-dom';
import { ThrowNotFound } from 'src/components/feedback/not-found';
import { LayoutContent } from 'src/components/layout/sidebar';

const Page = lazy(() => import('./page'));

export const AssignmentRegistrationSettings: FC = () => {
  return (
    <Switch>
      <Route path="/settings/assignment-registration">
        <Page />
      </Route>

      <Route>
        <LayoutContent>
          <ThrowNotFound />
        </LayoutContent>
      </Route>
    </Switch>
  );
};
